export const ON_GET_LOGS_ERROR = "ON_GET_LOGS_ERROR";
export const ON_EXPAND_TABLE = "ON_EXPAND_TABLE";
export const SET_SEARCH = "SET_SEARCH";
export const RESET_EXPANDED_ITEM = "RESET_EXPANDED_ITEM";
export const SET_SELECTED_ASSETS = "SET_SELECTED_ASSETS";
export const SET_SELECTED_STATUS = "SET_SELECTED_STATUS";
export const SET_SELECTED_MANAGEMENTS = "SET_SELECTED_MANAGEMENTS";
export const SET_AVAILABLE_ASSETS = "SET_AVAILABLE_ASSETS";
export const GET_COMPANY_GENERATING_UNITS = "GET_COMPANY_GENERATING_UNITS";
export const SET_AVAILABLE_STATUS = "SET_AVAILABLE_STATUS";
export const ON_TOGGLE_SELECT_ALL_ASSETS = "ON_TOGGLE_SELECT_ALL_ASSETS";
export const ON_TOGGLE_SELECT_FILTERED_ASSETS = "TOGGLE_SELECT_FILTERED_ASSETS";
export const INITIALIZE = "INITIALIZE";
export const UPDATE_MANAGEMENTS = "UPDATE_MANAGEMENTS";
export const DOWNLOAD_REPORT = "DOWNLOAD_REPORT";
export const UPLOAD_REPORT = "UPLOAD_REPORT";
export const ON_FILTER_CHANGE = "ON_FILTER_CHANGE";
export const FILTER_REPORT_ATTACHED_ITEMS = "FILTER_REPORT_ATTACHED_ITEMS";
export const FILTER_DIMISSED_ITEMS = "FILTER_DIMISSED_ITEMS";
export const SET_ALL_ASSETS_SELECTED = "SET_ALL_ASSETS_SELECTED";
export const SET_INITIAL_LOG_DATA = "LOAD_INITIAL_LOG_DATA";
export const ON_DATE_CHANGE = "ON_DATE_CHANGE";
export const ON_DATE_TIME_CHANGE = "ON_DATE_TIME_CHANGE";